import { Button, createStyles, Grid } from '@material-ui/core';
import React from 'react';

import { getColorTheme, getResellerTitle } from '~/src/dash/resellers/utils/importResellerConfig';
import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { bigRadius } from '~/src/dash/utils/material-dashboard-react';

interface IProps extends IWithStylesProps {}

const getMaintainanceImage = (): string => {
  switch (getResellerTitle()) {
    case 'Evrideo':
      return '/assets/shared/png/evrideo-maintenance.png';
    case 'Orka':
      return '/assets/shared/png/orka-maintenance.png';
    case 'OTTera':
      return '/assets/shared/png/ottera-maintenance.png';
    case 'Philo':
      return '/assets/shared/png/philo-maintenance.png';
    default:
      return '/assets/shared/png/ui-maintenance-slate.png';
  }
};

export const ConsoleDownView = decorate(
  {
    styles: () =>
      createStyles({
        consoleDownBackground: {
          position: 'fixed',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: '#F8FAFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
        uiMaintenancePlaceholder: {
          height: '35%',
          borderRadius: bigRadius,
          boxShadow: '0px 6px 12px #CBCBCB',
          marginBottom: '48px',
        },
        consoleDownHeader: {
          fontSize: '32px',
          fontWeight: 600,
          marginBottom: '15px',
        },
        consoleDownText: {
          fontSize: '18px',
          fontWeight: 400,
        },
        refreshButton: {
          marginTop: '35px',
          padding: '6px 18px',
        },
      }),
  },
  class extends React.Component<IProps> {
    render() {
      const { classes } = this.props;
      return (
        <Grid className={classes.consoleDownBackground}>
          <img
            className={classes.uiMaintenancePlaceholder}
            src={getMaintainanceImage()}
            alt={`${getResellerTitle()} UI Maintenance Image`}
          />
          <Grid item className={classes.consoleDownHeader}>
            We are re-connecting the dots.
          </Grid>
          <Grid item className={classes.consoleDownText}>
            Our App is under maintenance. We apologize for the inconvenience.
          </Grid>
          <Grid item className={classes.consoleDownText}>
            This should not last long, please try again later.
          </Grid>
          <Button
            style={{
              backgroundColor: getColorTheme('channelBidderPrimaryButton'),
              color: getColorTheme('channelBidderPrimaryButtonText'),
            }}
            className={classes.refreshButton}
            onClick={() => {
              if (window.location.href === '#/signin') {
                window.location.reload();
              } else {
                window.location.href = '/#/signin';
                window.location.reload();
              }
            }}
          >
            Refresh
          </Button>
        </Grid>
      );
    }
  },
);
